<h2 mat-dialog-title>{{ data.title || 'Confirm Action' }}</h2>

<mat-dialog-content>
  <p class="dialog-message">{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="close(false)">
    {{ data.cancelText || 'Cancel' }}
  </button>
  <button mat-flat-button color="primary" type="button" (click)="close(true)">
    {{ data.confirmText || 'Confirm' }}
  </button>
</mat-dialog-actions>
